import type { RecurringExpense } from './mock-data'

/**
 * 121 — which monthly costs are due, with no screen words, so the Worker (the
 * owner's Telegram) and the accounting page ask the same question the same
 * way. lib/recurring-expenses.ts re-exports these; its date words need the
 * app's dictionaries and stay there. Dates are 'YYYY-MM-DD' Tbilisi days.
 */

/** ASK costs whose month is waiting for its amount, oldest first. */
export function waitingForAmount(list: RecurringExpense[], today: string): RecurringExpense[] {
  return list
    .filter((r) => r.active && r.mode === 'ask' && r.next_due <= today)
    .sort((a, b) => a.next_due.localeCompare(b.next_due) || a.id.localeCompare(b.id))
}

/** `days` calendar days after `day`. */
export function addDays(day: string, days: number): string {
  const [y, m, d] = day.slice(0, 10).split('-').map(Number)
  return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10)
}

/** Running costs whose next day falls after today and within `days` — what money is about to be needed. */
export function comingUp(list: RecurringExpense[], today: string, days: number): RecurringExpense[] {
  const until = addDays(today, days)
  return list
    .filter((r) => r.active && r.next_due > today && r.next_due <= until)
    .sort((a, b) => a.next_due.localeCompare(b.next_due) || a.id.localeCompare(b.id))
}
